import { createContext, useContext } from 'react';

const ItemActivityContext = createContext<string>('');

export const ItemActivityIdProvider = ItemActivityContext.Provider;

export const useItemActivityId = () => useContext(ItemActivityContext);
